module.exports = __webpack_public_path__ + "media/images/cert-background-8-cd1b1fae438f38aa40a701b798f24e02.jpg";